import assertUnreachable from '../utils/assertUnreachable';
import { BigqueryAuthenticationType, DatabricksAuthenticationType, SnowflakeAuthenticationType, WarehouseTypes, } from './projects';
export var PersonSignInProvider;
(function (PersonSignInProvider) {
    PersonSignInProvider["GOOGLE"] = "google";
    PersonSignInProvider["SNOWFLAKE"] = "snowflake";
    PersonSignInProvider["DATABRICKS"] = "databricks";
})(PersonSignInProvider || (PersonSignInProvider = {}));
export var SignInSubjectBasis;
(function (SignInSubjectBasis) {
    SignInSubjectBasis["RECORDED"] = "recorded";
    SignInSubjectBasis["PROJECT_CREATOR"] = "project_creator";
})(SignInSubjectBasis || (SignInSubjectBasis = {}));
export const PERSON_SIGN_IN_LABELS = {
    [PersonSignInProvider.GOOGLE]: 'Google',
    [PersonSignInProvider.SNOWFLAKE]: 'Snowflake',
    [PersonSignInProvider.DATABRICKS]: 'Databricks',
};
export const getPersonSignIn = (credentials) => {
    switch (credentials.type) {
        case WarehouseTypes.BIGQUERY: {
            const keyfile = credentials.keyfileContents;
            if (credentials.authenticationType !==
                BigqueryAuthenticationType.ADC &&
                keyfile?.type === 'authorized_user' &&
                typeof keyfile.refresh_token === 'string' &&
                keyfile.refresh_token) {
                return {
                    provider: PersonSignInProvider.GOOGLE,
                    refreshToken: keyfile.refresh_token,
                };
            }
            return null;
        }
        case WarehouseTypes.SNOWFLAKE:
            return credentials.authenticationType ===
                SnowflakeAuthenticationType.SSO && credentials.refreshToken
                ? {
                    provider: PersonSignInProvider.SNOWFLAKE,
                    refreshToken: credentials.refreshToken,
                }
                : null;
        case WarehouseTypes.DATABRICKS:
            return credentials.authenticationType ===
                DatabricksAuthenticationType.OAUTH_U2M &&
                credentials.refreshToken
                ? {
                    provider: PersonSignInProvider.DATABRICKS,
                    refreshToken: credentials.refreshToken,
                }
                : null;
        case WarehouseTypes.REDSHIFT:
        case WarehouseTypes.POSTGRES:
        case WarehouseTypes.TRINO:
        case WarehouseTypes.CLICKHOUSE:
        case WarehouseTypes.ATHENA:
        case WarehouseTypes.DUCKDB:
            return null;
        default:
            return assertUnreachable(credentials, 'Unknown warehouse type');
    }
};
export const resolveSignInSubject = ({ signIn, actorUserUuid, stored, }) => {
    if (!signIn)
        return null;
    const match = stored.find((candidate) => candidate.refreshToken === signIn.refreshToken);
    return match ? match.subjectUserUuid : actorUserUuid;
};
export const getExpiredSharedSignInMessage = (expiry, viewerUserUuid) => {
    const signIn = PERSON_SIGN_IN_LABELS[expiry.provider];
    const name = expiry.subjectName?.trim();
    const nobodyMessage = `This project's connection uses a ${signIn} sign-in that has expired. Ask a project admin to reconnect it in Project settings → Connection settings.`;
    if (viewerUserUuid === null)
        return nobodyMessage;
    switch (expiry.subjectBasis) {
        case SignInSubjectBasis.RECORDED:
            if (expiry.subjectUserUuid === viewerUserUuid) {
                return `Your ${signIn} sign-in for this project's connection has expired. Reconnect it in the project's connection settings.`;
            }
            return name
                ? `This project's connection uses ${name}'s sign-in, which has expired. Ask ${name} or an admin to reconnect.`
                : nobodyMessage;
        case SignInSubjectBasis.PROJECT_CREATOR:
            if (expiry.subjectUserUuid === viewerUserUuid) {
                return `This project's ${signIn} sign-in has expired. You created this project. Reconnect it in Project settings → Connection settings.`;
            }
            return name
                ? `This project's ${signIn} sign-in has expired. ${name} created this project. Ask them or a project admin to reconnect it in Project settings → Connection settings.`
                : nobodyMessage;
        case null:
            return nobodyMessage;
        default:
            return assertUnreachable(expiry.subjectBasis, 'Unknown sign-in subject basis');
    }
};
//# sourceMappingURL=sharedSignIn.js.map